export const ACCORDION_INITIAL_DATA = {
  type: 'accordion',
  data: {
    spoilers: [
      {
        title: 'New Section',
        children: [
          {
            data: {},
            type: 'text',
          },
        ],
      },
    ],
  },
};
